export const APP_NAME = process.env.REACT_APP_APP_NAME || "ParshCare";
export const CLINIC_NAME = process.env.REACT_APP_CLINIC_NAME || "Acharya Tulsi Diagnostic Center";
